export const FETCH_RAFLIST_REQUEST = 'FETCH_RAFLIST_REQUEST'
export const FETCH_RAFLIST_SUCCESS = 'FETCH_RAFLIST_SUCCESS'
export const FETCH_RAFLIST_FAILURE = 'FETCH_RAFLIST_FAILURE'
export const FETCH_RAFLIST_UPDATE = 'FETCH_RAFLIST_UPDATE'

